module.exports = __webpack_public_path__ + "static/media/site-builder-br.489b1053.png";